/**
 * Вспомогательный класс, предназначенный для управления цветами 
 * (получения очереди цветов из числа заранее подготовленных)
 */
export class ColorScheme {

    /**
     * Текущий номер цвета в массиве
     */
    private position: number;

    /**
     * массив цветов
     */
    private colors: string [] = [
        '#c0392b',
        '#d35400',
        '#f39c12',
        '#f1c40f',
        '#2ecc71',
        '#27ae60',
        '#16a085',
        '#1abc9c',
        '#3498db',
        '#2980b9',
        '#8e44ad',
        '#9b59b6',
        '#34495e',
        '#2c3e50',
    ];

    /**
     * конструктор
     */
    constructor() {
        this.position = 0;
    }

    /**
     * Получить следующий код цвета rgb
     */
    public getNext(): string {
        const color = this.colors[this.position];
        this.position++;
        if (this.position === this.colors.length) {
            this.position = 0;
        }
        return color;
    }

    /**
     * обнулить состояние (вернуться к первому цвету)
     */
    public resetPosition(): void {
        this.position = 0;
    }
}